import Tender from './Tender';

export default Tender;